import { FileTextIcon } from 'lucide-react'

import { registerSplitViewContent } from '../../split-view.registry'
import type { ContentBriefData } from './content-brief.interface'
import { ContentBriefContent } from './content-brief-content.molecule'
import { isContentBriefData } from './content-brief-validators.helper'

export const registerContentBriefContent = (): void => {
  registerSplitViewContent<ContentBriefData>({
    type: 'content-brief',
    title: 'Content Brief',
    subtitle: (data) => `${data.name} v${data.version}`,
    icon: FileTextIcon,
    component: ContentBriefContent,
    isValidData: isContentBriefData,
  })
}
